import { useSelector } from 'react-redux';
import { getStoreName } from '../../authSlice/authSelectors';

function useStoreName(): string {
  return useSelector(getStoreName);
}

export default useStoreName;
